import { render, staticRenderFns } from "./EditPersetujuanLpmok.vue?vue&type=template&id=1b05eeae&scoped=true&"
import script from "./EditPersetujuanLpmok.vue?vue&type=script&lang=js&"
export * from "./EditPersetujuanLpmok.vue?vue&type=script&lang=js&"
import style0 from "./EditPersetujuanLpmok.vue?vue&type=style&index=0&id=1b05eeae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b05eeae",
  null
  
)

export default component.exports